import { render } from "./pictureCapture.vue?vue&type=template&id=4e0196ae&scoped=true&ts=true"
import script from "./pictureCapture.vue?vue&type=script&lang=ts"
export * from "./pictureCapture.vue?vue&type=script&lang=ts"

import "./pictureCapture.vue?vue&type=style&index=0&id=4e0196ae&scoped=true&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e0196ae"]])

export default __exports__